import styled from 'styled-components';

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`;

export const Row = styled.div`
  display: flex;
  gap: 16px;
  @media (max-width: 600px) {
    flex-direction: column;
  }
  > * {
    flex: 1;
  }
`;

export const PillsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;

  > span {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const GroupLabel = styled.label`
  display: inline-block;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray};
  margin-bottom: 4px;
`;

export const GroupError = styled.span`
  font-style: italic;
  margin-left: 4px;
  color: ${({ theme }) => theme.colors.error};
`;

export const Description = styled.div<{ $center?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
  ${({ $center }) => $center && 'text-align: center;'}
`;
export const DescriptionText = styled.p`
  font-size: 14px;
  margin: 0;
  color: ${({ theme }) => theme.colors.grey450};
`;

export const Link = styled.a`
  color: ${({ theme }) => theme.colors.grey500};
  text-decoration: underline;
  text-decoration-color: ${({ theme }) => theme.colors.grey500};
`;
